import { type WalletComputedCurrencyConversionRates } from '@capsicum/common';
import { useConversionRatesQuery } from '@capsicum/socios-core';

export const useConversionRates = (conversionRates: WalletComputedCurrencyConversionRates) => {
	return useConversionRatesQuery(conversionRates);
};
